import { toast } from 'react-toastify';
import { Specialist, SpecialistList, UnitFilter, UnitHealthPlans } from '../models/Specialist';
import { Specialty, SpecialtyById } from '../models/Specialty';
import { lambdaValidateApi, specialistsApi, specialistsApiV2 } from '../services/api';
import { ResponseAPI } from './responseApi';
import { HealthPlan } from '../models/HelthPlan';
import { SystemUnavailableError } from '../errors';

let controller = new AbortController();
export const fetchSpecialists = async (props: {
  specialty?: string;
  name?: string;
  medical_indicator?: number;
  units?: string;
  area_expertise?: string;
  medical_field?: string;
}) => {
  const result: ResponseAPI<SpecialistList[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as SpecialistList[]
  };
  try {
    controller.abort();
    controller = new AbortController();
    const response = await lambdaValidateApi.get(`specialists`, {
      params: {
        name: props.name,
        limit: 60,
        active: 1,
        ...props
      },
      signal: controller.signal
    });
    result.data = response.data.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    return result;
  }
};

export const fetchSpecialistsV2 = async (props: {
  specialty?: string;
  name?: string;
  medical_indicator?: number;
  unit?: string;
  area_expertise?: string;
  medical_field?: string;
  show_unavailable_on_digital_platform?: number;
}) => {
  const result: ResponseAPI<SpecialistList[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as SpecialistList[]
  };
  try {
    controller.abort();
    controller = new AbortController();
    const response = await specialistsApiV2.get(`/v2/specialists`, {
      params: {
        name: props.name,
        limit: 60,
        active: 1,
        ...props
      },
      signal: controller.signal
    });
    result.data = response.data.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    return result;
  }
};

export const fetchSpecialistById = async (id: string): Promise<ResponseAPI<Specialist>> => {
  const result: ResponseAPI<Specialist> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as Specialist
  };
  try {
    const response = await lambdaValidateApi.get(`specialists/${id}`);

    result.data = response.data;

    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    return result;
  }
};

export const fetchSpecialistByIdV2 = async (id: string): Promise<ResponseAPI<Specialist>> => {
  const result: ResponseAPI<Specialist> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as Specialist
  };
  try {
    const response = await specialistsApiV2.get(`v2/specialists/${id}/public`, {
      headers: {
        'X-Tenant-Id': 'einstein'
      }
    });

    result.data = response.data;

    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    toast.error('Não foi possível buscar dados do médico');

    return result;
  }
};

export const fetchSpecialistMedicalCare = async (props: { specialistId: string; officeId: string }) => {
  const result: ResponseAPI<UnitHealthPlans> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as UnitHealthPlans
  };
  try {
    const response = await lambdaValidateApi.get(
      `specialists/${props.specialistId}/offices/${props.officeId}/medical-care-infos`,
      {}
    );
    result.data = response?.data?.data;

    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    return result;
  }
};

export const fetchSpecialties = async () => {
  const result: ResponseAPI<Specialty[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as Specialty[]
  };
  try {
    const response = await lambdaValidateApi.get(`validate-specialties`, {
      params: { medical_indicator: 1 }
    });
    result.data = response.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    return result;
  }
};

export const fetchPublicSpecialties = async () => {
  const result: ResponseAPI<Specialty[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as Specialty[]
  };
  try {
    const response = await specialistsApi.get(`/specialists/specialties`, {
      params: {}
    });
    result.data = response.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    return result;
  }
};

export const fetchSpecialtiesById = async (specialtyId: string) => {
  const result: ResponseAPI<SpecialtyById> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as SpecialtyById
  };
  try {
    const response = await lambdaValidateApi.get(`validate-specialties/${specialtyId}`);
    result.data = response.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    return result;
  }
};

export const fetchUnitsFilter = async (passParams = true) => {
  const result: ResponseAPI<UnitFilter[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as UnitFilter[]
  };
  try {
    const params: { medical_indicator?: number; hasSchedulingContact?: number } = {
      medical_indicator: 1,
      hasSchedulingContact: 1
    };

    if (!passParams) {
      params.hasSchedulingContact = undefined;
      params.medical_indicator = undefined;
    }

    const response = await specialistsApi.get(`specialists/public/units`, { params });
    result.data = response.data;
    return result;
  } catch (error) {
    result.error = true;
    console.error(error);
    return result;
  }
};

export const fetchHealthPlanBySubGroup = async (params: { value: string }) => {
  try {
    const response = await specialistsApiV2.get(`/health-plans/by-subgroup`, { params });
    return response.data as HealthPlan;
  } catch (error: any) {
    throw new SystemUnavailableError(error.message);
  }
};
